module.exports = __webpack_public_path__ + "static/media/muck-truck-max.23de7356.jpg";